import { Box, TextField, IconButton, CircularProgress } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

export const GroupNameEditor = ({
  editedName,
  setEditedName,
  handleSave,
  handleCancel,
  handleKeyPress,
  isUpdatingGroupName = false,
}: {
  editedName: string;
  setEditedName: (name: string) => void;
  handleSave: () => void;
  handleCancel: () => void;
  handleKeyPress: (event: React.KeyboardEvent) => void;
  isUpdatingGroupName?: boolean;
}) => (
  <Box
    display='flex'
    alignItems='center'
    gap='4px'
    marginBottom='4px'
    height='18px'
    minHeight='18px'
    component='form'
    onSubmit={event => {
      event.preventDefault();
      event.stopPropagation();
      handleSave();
    }}
  >
    <TextField
      value={editedName}
      onChange={event => setEditedName(event.target.value)}
      onKeyDown={handleKeyPress}
      size='small'
      autoFocus
      disabled={isUpdatingGroupName}
      sx={{
        flex: 1,
        '& .MuiInputBase-root': {
          fontSize: '12px',
          fontWeight: 500,
          height: '18px',
          minHeight: '18px',
        },
        '& .MuiInputBase-input': {
          padding: '0 6px',
          height: '18px',
          lineHeight: '18px',
        },
      }}
    />
    <IconButton size='small' onClick={handleSave} disabled={isUpdatingGroupName} sx={{ padding: '2px' }}>
      {isUpdatingGroupName ? (
        <CircularProgress size={16} sx={{ color: 'inherit' }} />
      ) : (
        <CheckIcon sx={{ fontSize: '16px' }} />
      )}
    </IconButton>
    <IconButton size='small' onClick={handleCancel} disabled={isUpdatingGroupName} sx={{ padding: '2px' }}>
      <CloseIcon sx={{ fontSize: '16px' }} />
    </IconButton>
  </Box>
);
